import React from "react";
import Modal from ".";

export interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  variant?: "primary" | "danger";
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = "Are you sure?",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  const confirmBtnBase =
    "inline-flex items-center justify-center px-4 py-2 rounded-lg font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed";
  const confirmBtnVariant =
    variant === "danger"
      ? "bg-red-600 text-white hover:bg-red-700"
      : "bg-primary-600 text-white hover:bg-primary-700";

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title}>
      {message && <div className="text-neutral-700">{message}</div>}

      <div className="mt-4 flex items-center justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {cancelText}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          className={`${confirmBtnBase} ${confirmBtnVariant}`}
        >
          {loading && (
            <span className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
          )}
          {confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
